var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile-tips"}},_vm._l((_vm.tips),function(tip){return _c('article',{key:tip.key,staticClass:"message is-success"},[_c('div',{staticClass:"message-body"},[_vm._v("\n      "+_vm._s(tip)+"\n    ")])])}))}
var staticRenderFns = []

export { render, staticRenderFns }